/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField, LinkFieldProps } from 'framework/ui/field';
import useRedmineUrl from 'infrastructure/integrations/redmine/useRedmineUrl';

const ProjectField = ({ source, nameSource, ...props }: LinkFieldProps) => {
  const { getValue: getId } = useFieldHelper<number>({ source });
  const { getValue: getName } = useFieldHelper<number>({ source: nameSource });
  const { getProjectUrl } = useRedmineUrl();

  const id = getId();
  const value = id && getProjectUrl(id);

  return <LinkField {...props} linkText={nameSource ? getName() : id} value={value as string} isInternal={false} />;
};

export default ProjectField;
